import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { Audience } from '../../interfaces/audience.model';
import { Language } from '../../interfaces/language.model';
import { CategoriesProvider } from '../categories/categories';
import { KeywordProvider } from '../keyword/keyword';
import { IndicationProvider } from '../indication/indication';
import { AssetProvider } from '../asset/asset';
import { NotificationProvider } from '../notification/notification';
import { Action } from '../../interfaces/action.model';
import { HelperProvider } from '../helper/helper';
import { LanguageProvider } from '../language/language';
import { AudienceProvider } from '../audience/audience';
import { LocalfileProvider } from '../localfile/localfile';

@Injectable()
export class StorageProvider {
  public static readonly ACTION_OPEN = "OPEN";
  public static readonly ACTION_SHARE = "SHARE";

  languages: Language[];
  audiences: Audience[];
  notifications: Notification[];
  userAction: Action;

  constructor(
    public http: HttpClient, 
    public storage: Storage, 
    public categoriesService: CategoriesProvider, 
    public assetService: AssetProvider, 
    public keywordService: KeywordProvider, 
    public indicationService: IndicationProvider, 
    public notificationService: NotificationProvider,
    public helperService: HelperProvider,
    public languageService: LanguageProvider,
    public audienceService: AudienceProvider,
    public localfileService: LocalfileProvider) {}


  setDataStorage(key, value) {
    return this.storage.set(key, value);
  }

  getDataStorage(key) {
    return this.storage.get(key);
  }

  removeDataStorage(key){
    return this.storage.remove(key);
  }

  getAllDataFromStorage(){
    return new Promise((resolve, reject) => {
      let p1 = this.categoriesService.getCategories();
      let p2 = this.assetService.getAssets();
      let p3 = this.assetService.getAssetTypes();
      let p4 = this.languageService.getLanguages();
      let p5 = this.audienceService.getAudiences();
      let p6 = this.indicationService.getIndications();
      let p7 = this.keywordService.getKeywords();
      let p8 = this.notificationService.getNotifications();
      let p9 = this.localfileService.getLocalFiles();
      Promise.all([p1, p2, p3, p4, p5, p6, p7, p8, p9]).then(data => { 
        resolve(data);
      });
    });
  }

  getUser(){
    return this.getDataStorage("user");
  }

  setUserActions(assetId, action){
    let userAction: Action = {
      AssetId: assetId,
      Action: action,
      ActionDate: this.helperService.getFullDate(2),
    }

    this.getDataStorage("userActions").then((userActions:Action[]) => {
      let arrayUserAction = userActions;
      if(arrayUserAction !== null){
        arrayUserAction.push(userAction);
        this.setDataStorage("userActions", arrayUserAction);
      } else {
        arrayUserAction = [userAction];
        this.setDataStorage("userActions", arrayUserAction);
      }
    });
  }

} 



// WEBPACK FOOTER //
// ./src/providers/storage/storage.ts